import React from "react";
import { Container } from "@mui/system";
import { Grid, Typography, Box } from "@mui/material";
import globals from "../globals";
import RedButton from "../components/redButton";

export default function ComingSoonPage() {

  return (
    <Container>
      <Grid container justifyContent="space-evenly" alignItems="center" >
        <Grid item xs={10} sm={4}>
          <img src='coming_soon.webp' style={{ height: 300, width: 300 }}></img>
        </Grid>
        <Grid item textAlign={'center'} xs={10} sm={5}>
          <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold' }}>Очаквайте скоро!</Typography>
          <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt:4 }}>Съвсем скоро тук ще намерите
нова, интересна и полезна информация.</Typography>

          <Grid container justifyContent={'center'}>
            <RedButton text={"Към началото"} mTop={5} pX={4} href={'/'}/>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}